import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="flex flex-col justify-start items-center gap-y-5 mb-32">
      <h1 className="mt-3 font-bold text-3xl capitalize w-96">
        Terms and Conditions
      </h1>
      <p className="w-96 text-sm">
        By accessing this website we assume you accept these terms and
        conditions in full.
      </p>
      <p className="w-96 text-sm">
        Do not continue to use pokeprice.io's website if you do not accept all
        of the terms and conditions stated on this page.
      </p>
      <p className="w-96 text-sm">
        The following terminology applies to these Terms and Conditions, Privacy
        Statement and Disclaimer Notice and any or all Agreements: "Client",
        "You" and "Your" refers to you, the person accessing this website and
        accepting the Company's terms and conditions.
      </p>
      <p className="w-96 text-sm">
        "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company.
        "Party", "Parties", or "Us", refers to both the Client and ourselves, or
        either the Client or ourselves.
      </p>
      <p className="w-96 text-sm">
        All terms refer to the offer, acceptance and consideration of payment
        necessary to undertake the process of our assistance to the Client in
        the most appropriate manner, whether by formal meetings of a fixed
        duration, or any other means, for the express purpose of meeting the
        Client's needs in respect of provision of the Company's stated
        services/products, in accordance with and subject to, prevailing law of
        the UK.
      </p>
      <p className="w-96 text-sm">
        Any use of the above terminology or other words in the singular, plural,
        capitalisation and/or he/she or they, are taken as interchangeable and
        therefore as referring to same.
      </p>
      <h2 className="font-bold text-md capitalize w-96">Cookies</h2>
      <p className="w-96 text-sm">We employ the use of cookies.</p>
      <p className="w-96 text-sm">
        By using pokeprice.io's website you consent to the use of cookies in
        accordance with pokeprice.io's privacy policy.
      </p>
      <p className="w-96 text-sm">
        Most of the modern day interactive web sites use cookies to enable us to
        retrieve user details for each visit.
      </p>
      <p className="w-96 text-sm">
        Cookies are used in some areas of our site to enable the functionality
        of this area and ease of use for those people visiting.
      </p>
      <p className="w-96 text-sm">
        Some of our affiliate / advertising partners may also use cookies.
      </p>
      <h2 className="font-bold text-md capitalize w-96">License</h2>
      <p className="w-96 text-sm">
        Unless otherwise stated, pokeprice.io and/or it's licensors own the
        intellectual property rights for all material on pokeprice.io.
      </p>
      <p className="w-96 text-sm">
        All intellectual party rights are reserved.
      </p>
      <p className="w-96 text-sm">
        You may view and/or print pages from https://pokeprice.io for your own
        personal use subject to restrictions set in these terms and conditions.
      </p>
      <p className="w-96 text-sm">You must not:</p>
      <ul className="list-disc ml-14 w-96">
        <li>Republish material from https://pokeprice.io</li>
        <li>Sell, rent or sub-license material from https://pokeprice.io</li>
        <li>Reproduce, duplicate or copy material from https://pokeprice.io</li>
        <li>
          Redistribute content from https://pokeprice.io (unless content is
          specifically made for redistribution)
        </li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">User Comments</h2>
      <p className="w-96 text-sm">
        This agreement shall begin on the day hereof
      </p>
      <p className="w-96 text-sm">
        Certain parts of this website offer the opportunity for users to post
        and exchange opinions, information, material and data ('Comments') in
        areas of the website.
      </p>
      <p className="w-96 text-sm">
        You may view and/or print pages from https://pokeprice.io for your own
        personal use subject to restrictions set in these terms and conditions.
      </p>
      <p className="w-96 text-sm">
        Comments reflect the view and opinion of the person who posts such view
        or opinion.
      </p>
      <p className="w-96 text-sm">
        To the extent permitted by applicable laws pokeprice.io shall not be
        responsible or liable for the Comments or for any loss cost, liability,
        damages or expenses caused and or suffered as a result of any use of
        and/or posting of and/or appearance of the Comments on this website.
      </p>
      <p className="w-96 text-sm">
        Pokeprice.io reserves the right to monitor all Comments and to remove
        any Comments which it considers in its absolute discretion to be
        inappropriate, offensive or otherwise in breach of these Terms and
        Conditions.
      </p>
      <p className="w-96 text-sm">You warrant and represent that:</p>
      <ul className="list-disc ml-14 w-96">
        <li>
          You are entitled to post the Comments on our website and have all
          necessary licenses and consents to do so.
        </li>
        <li>
          The Comments do not infringe any intellectual property right,
          including without limitation copyright, patent or trademark, or other
          proprietary right of any third party.
        </li>
        <li>
          The Comments do not contain any defamatory, libelous, offensive,
          indecent or otherwise unlawful material or material which is an
          invasion of privacy.
        </li>
        <li>
          The Comments will not be used to solicit or promote business or custom
          or present commercial activities or unlawful activity.
        </li>
      </ul>
      <p className="w-96 text-sm">
        You hereby grant to pokeprice.io a non-exclusive royalty-free license to
        use, reproduce, edit and authorize others to use, reproduce and edit any
        of your Comments in any and all forms, formats or media.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        Hyperlinking to our Content
      </h2>
      <p className="w-96 text-sm">
        The following organizations may link to our Web site without prior
        written approval:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>Government agencies</li>
        <li>Search Engines</li>
        <li>News Organizations</li>
        <li>
          Online directory distributors when they list us in the directory may
          link to our Web site in the same manner as they hyperlink to the Web
          sites of other listed businesses.
        </li>
        <li>
          Systemwide Accredited Businesses except soliciting non-profit
          organizations, charity shopping malls, and charity fundraising groups
          which may not hyperlink to our Web site.
        </li>
      </ul>
      <p className="w-96 text-sm">
        These organizations may link to our home page, to publications or to
        other Web site information so long as the link:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>is not in any way misleading</li>
        <li>
          does not falsely imply sponsorship, endorsement or approval of the
          linking party and its products or services
        </li>
        <li>fits within the context of the linking party's site</li>
      </ul>
      <p className="w-96 text-sm">
        We may consider and approve in our sole discretion other link requests
        from the following types of organizations:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>
          Commonly-known consumer and/or business information sources such as
          Chambers of Commerce, American Automobile Association, AARP and
          Consumers Union.
        </li>
        <li>dot.com community sites.</li>
        <li>
          Associations or other groups representing charities, including charity
          giving sites, online directory distributors.
        </li>
        <li>Internet portals</li>
        <li>
          Accounting, law and consulting firms whose primary clients are
          businesses.
        </li>
        <li>Educational institutions and trade associations.</li>
      </ul>
      <p className="w-96 text-sm">
        We will approve link requests from these organizations if we determine
        that:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>
          The link would not reflect unfavorably on us or our accredited
          businesses (for example, trade associations or other organizations
          representing inherently suspect types of business, such as
          work-at-home opportunities, shall not be allowed to link).
        </li>
        <li>
          The organization does not have an unsatisfactory record with us.
        </li>
        <li>
          The organization does not have an unsatisfactory record with us.
        </li>
        <li>
          Where the link is in the context of general resource information or is
          otherwise consistent with editorial content in a newsletter or similar
          product furthering the mission of the organization.
        </li>
      </ul>
      <p className="w-96 text-sm">
        These organizations may link to our home page, to publications or to
        other Web site information so long as the link:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>Is not in any way misleading.</li>
        <li>
          Does not falsely imply sponsorship, endorsement or approval of the
          linking party and it products or services.
        </li>
        <li>Fits within the context of the linking party's site.</li>
      </ul>
      <p className="w-96 text-sm">
        If you are among the organizations listed in paragraph 2 above and are
        interested in linking to our website, you must notify us by sending an
        e-mail to doog@pokeprice.io
      </p>
      <p className="w-96 text-sm">
        Please include your name, your organization name, contact information
        (such as a phone number and/or e-mail address) as well as the URL of
        your site, a list of any URLs from which you intend to link to our Web
        site, and a list of the URL(s) on our site to which you would like to
        link.
      </p>
      <p className="w-96 text-sm">Allow 2-3 weeks for a response.</p>
      <p className="w-96 text-sm">
        Approved organizations may hyperlink to our Web site as follows:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>By use of our corporate name.</li>
        <li>
          By use of the uniform resource locator (Web address) being linked to.
        </li>
        <li>
          By use of any other description of our Web site or material being
          linked to that makes sense within the context and format of content on
          the linking party's site.
        </li>
      </ul>
      <p className="w-96 text-sm">
        No use of Doodl.la's logo or other artwork will be allowed for linking
        absent a trademark license agreement.
      </p>

      <h2 className="font-bold text-md capitalize w-96">Iframes</h2>

      <p className="w-96 text-sm">
        Without prior approval and express written permission, you may not
        create frames around our Web pages or use other techniques that alter in
        any way the visual presentation or appearance of our Web site.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        Reservation of rights
      </h2>

      <p className="w-96 text-sm">
        We reserve the right at any time and in its sole discretion to request
        that you remove all links or any particular link to our Web site.
      </p>
      <p className="w-96 text-sm">
        You agree to immediately remove all links to our Web site upon such
        request.
      </p>
      <p className="w-96 text-sm">
        We also reserve the right to amend these terms and conditions and its
        linking policy at any time.
      </p>
      <p className="w-96 text-sm">
        By continuing to link to our Web site, you agree to be bound to and
        abide by these linking terms and conditions.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        Removal of links from our website
      </h2>

      <p className="w-96 text-sm">
        If you find any link on our Web site or any linked web site
        objectionable for any reason, you may contact us about this.
      </p>
      <p className="w-96 text-sm">
        We will consider requests to remove links but will have no obligation to
        do so or to respond directly to you.
      </p>
      <p className="w-96 text-sm">
        Whilst we endeavour to ensure that the information on this website is
        correct, we do not warrant its completeness or accuracy; nor do we
        commit to ensuring that the website remains available or that the
        material on the website is kept up to date.
      </p>
      <h2 className="font-bold text-md capitalize w-96">Content Liability</h2>

      <p className="w-96 text-sm">
        We shall have no responsibility or liability for any content appearing
        on your Web site.
      </p>
      <p className="w-96 text-sm">
        You agree to indemnify and defend us against all claims arising out of
        or based upon your Website.
      </p>
      <p className="w-96 text-sm">
        No link(s) may appear on any page on your Web site or within any context
        containing content or materials that may be interpreted as libelous,
        obscene or criminal, or which infringes, otherwise violates, or
        advocates the infringement or other violation of, any third party
        rights.
      </p>
      <h2 className="font-bold text-md capitalize w-96">Disclaimer</h2>

      <p className="w-96 text-sm">
        To the maximum extent permitted by applicable law, we exclude all
        representations, warranties and conditions relating to our website and
        the use of this website (including, without limitation, any warranties
        implied by law in respect of satisfactory quality, fitness for purpose
        and/or the use of reasonable care and skill).
      </p>
      <p className="w-96 text-sm">Nothing in this disclaimer will:</p>
      <ul className="list-disc ml-14 w-96">
        <li>
          Limit or exclude our or your liability for death or personal injury
          resulting from negligence.
        </li>
        <li>
          Limit or exclude our or your liability for fraud or fraudulent
          misrepresentation.
        </li>
        <li>
          Limit any of our or your liabilities in any way that is not permitted
          under applicable law.
        </li>
        <li>
          Exclude any of our or your liabilities that may not be excluded under
          applicable law.
        </li>
      </ul>
      <p className="w-96 text-sm">
        The limitations and exclusions of liability set out in this Section and
        elsewhere in this disclaimer:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>are subject to the preceding paragraph</li>
        <li>
          govern all liabilities arising under the disclaimer or in relation to
          the subject matter of this disclaimer, including liabilities arising
          in contract, in tort (including negligence) and for breach of
          statutory duty.
        </li>
      </ul>
      <p className="w-96 text-sm">
        To the extent that the website and the information and services on the
        website are provided free of charge, we will not be liable for any loss
        or damage of any nature.
      </p>
    </div>
  );
};

export default TermsAndConditions;
